import { FaFileUpload } from "react-icons/fa";
import TeacherLayout from "./TeacherLayout";
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import { IoIosAddCircle } from "react-icons/io";
import { useFirebase } from 'react-redux-firebase';
import { useParams } from "react-router-dom";
import {  addResultAction } from '../../../Firebase/actions/addResultAction';
import { connect } from 'react-redux';
import CustomizedSnackbars from "../../Feedback";


const StudentResult = ({  addResultAction, addResultSuccess, addResultError, resetSuccess }) => {
    const { id } = useParams();
    const [file, setFile] = useState('');
    const [term, setTerm] = useState('');
    const [error, setError] = useState(false);

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();

    const handleSubmit = (e) => {
        e.preventDefault();

        if( term === '' || file === '') {
            setError(true);
            return;
        } else  {
            setError(false);
            
            // storagee references
            const storageRef = firebase.storage().ref(`results/${id}`);


            storageRef.put(file).on('state change', (snap) => {
                document.getElementById('Btn').classList.add('is-loading');
            }, (err) => {
                setError(err.message);
            }, async () => {

                const uploadedFileUrl = await storageRef.getDownloadURL();
                //console.log(uploadedFileUrl);
                document.getElementById('Btn').classList.remove('is-loading');

                let result = {
                    term,
                    uploadedFileUrl,
                    id   
                }
                addResultAction(result);
            }); 
        }
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });

        if(addResultSuccess) {
            document.getElementById('Btn').classList.remove('is-loading');
            //reset form
            setFile('');
            
            //on success
            setFeedbackText('Result upload successfully.');
            setSeverity('success');
            setOpenFeedback(true);
           
            resetSuccess();
        }

        if(addResultError) {
            document.getElementById('Btn').classList.remove('is-loading');
            //on error
            setFeedbackText('Error occured.');
            setSeverity('error');
            setOpenFeedback(true);
        }
    }, [addResultSuccess, addResultError, resetSuccess]);
    return ( 
        <TeacherLayout>
            <div className="pt-4">
                <div className="container">
                    <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">Name Surname:</h5>
                    <div className="divider mb-5"></div>
                    <form onSubmit={handleSubmit}>
                        <div className="row mt-5">
                            <div className="col s12 m4">
                                <div className="file-field input-field">
                                    <div
                                        className="button is-small is-info"
                                    >
                                        <span className="icon">
                                            <FaFileUpload />
                                        </span>
                                        <span>Select File</span>
                                        <input 
                                            type="file" 
                                            onChange={(e) => setFile(e.target.files[0])} 
                                            accept="application/pdf"
                                        />
                                    </div>
                                    <div className="file-path-wrapper">
                                        <input className="file-path" type="text" placeholder="Select a PDF file" />
                                    </div>
                                </div>
                            </div>     
                            <div className="col s12 m3 offset-l1">
                                <div className="input-field">
                                    <select onChange={(e) => setTerm(e.target.value)} value={term}>
                                        <option value="" disabled>Select</option>
                                        <option value="Term One Result">Term One</option>
                                        <option value="Term Two Result">Term Two</option>
                                        <option value="Term Three Result">Term Three</option>
                                    </select>
                                    <label>Term: </label>
                                </div>
                            </div>
                            <div className="control">
                                <button className="button is-success mt-3" id="Btn">
                                    <span className="icon">
                                        <IoIosAddCircle size="1.25rem" color="white"/>
                                    </span>
                                    <span className="white-text">Add Result</span>
                                </button>
                            </div>
                            {
                                error && <p className="mt-4 mb-6 main-color-text">Please select a valid file and term.</p>
                            }
                        </div>
                    </form>
                    
                </div>
            </div>
            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </TeacherLayout>
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state)
    return {
        addResultSuccess: state.addResult.addResultSuccess,
        addResultError: state.addResult.addResultError
    }
    
}
 

const mapDispatchToProps = (dispatch) => {
    return {
        addResultAction: (result) => dispatch(addResultAction(result)),
        resetSuccess: () => dispatch({ type: "ADD_RESULT", success: false })
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(StudentResult);
